module.exports = __webpack_public_path__ + "static/img/award2_active.3402449.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index/award2_active.png
// module id = KoqK
// module chunks = 7